<template>

  <div class="awsacct-validation">
    <v-container fluid>
      <v-card class="pa-3" style="margin-bottom:15px; color:#fff" v-if="type === 'New'">
        <v-form>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 xl12>
            <h3 style="color:#000">Customer Information</h3>
            <span style="color:#000;font-size:14px;font-weight:500;margin-bottom:20px">NOTE: All fields with <span style="color:red">*</span> are required</span>
          </v-flex>
          <v-flex xs12 sm12 md5 xl5>
            
            <v-text-field v-model="awsAccountOnboarding.fields.Tmp_Cust_Name" 
              v-validate="'required'"
               data-vv-name="Customer Name" 
                data-vv-validate-on="blur"
                :error-messages="errors.collect('Customer Name')"
                :disabled= "awsAccountOnboarding.fields.Tmp_Cust_Name"
                outlined
            dense
            >
               <template slot="label"> <span style="font-size: 135%" v-html="`Customer Name <span style='color:red' class='required'>*</span>`"/></template> 
            </v-text-field>
            
          </v-flex>
          <v-flex xs12 sm12 md3 xl3>
            <v-autocomplete
              v-model="awsAccountOnboarding.fields.Cust_Region"
              :items="dxcRegions"
              placeholder="Select Customer Region"
              v-validate="'required'"
              data-vv-name="Customer Region" 
              data-vv-validate-on="blur"
              :error-messages="errors.collect('Customer Region')"
              hint="Example: APJ-MEA, Americas, Europe, UKI"
              @change = "getCustomerRegion"
              attach
               outlined
            dense
            >
            <template slot="label"><span style="font-size: 135%" v-html="`Customer Region <span style='color:red' class='required'>*</span>`"></span></template> 
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md4 xl4>
            <v-text-field
              placeholder="Customer_Alias"
              :counter="15"
              v-model="awsAccountOnboarding.fields.Customer_Alias"
              
              v-validate="'required'"
              data-vv-name="Customer Alias"
              :error-messages="errors.collect('Customer Alias')"
              hint="Example: For customer named Blue Scope Limited, alias/short name can be 'BlueScope' or 'BSL'."
               outlined
            dense
            >
                <template slot="label"><span style="font-size: 135%" v-html="`Please provide a short name for the customer. <span style='color:red' class='required'>*</span>`"></span></template>
            </v-text-field>
          </v-flex>
          
        </v-layout>
        </v-form>
      </v-card>
      <v-card class="pa-3">
        <h3>WBS Validation</h3>
        <span style="color:#ffffff">Type: {{ type }}</span>
        <v-form>
          <v-layout
            row
            wrap>
            <v-flex
              xs12
              sm6
              md5>
              <v-text-field
                v-model="awsAccountValidation.wbsCode"
                :loading="awsAccountValidation.wbsValidating"
                :success="awsAccountValidation.wbsCodeValidated"
                :error="!awsAccountValidation.wbsCodeValidated"
                :messages="awsAccountValidation.wbsValidationMessage"
                label="Enter WBS Code"
                outlined
                @keypress="onWbsChange" >
                <template v-slot:append>
                  <v-btn
                    :color="awsAccountValidation.wbsCodeValidated ? 'orange' : ''"
                    class="my-0"
                    small
                    @click="onWbsValidate"
                  >
                    <span v-if="!awsAccountValidation.wbsCodeValidated">validate</span>
                    <v-icon
                      v-else
                      small>check</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
              <p>Note: Please provide a C1 WBS code under entity 1571.  If you are unable to provide a C1 WBS, please create an IWO WBS under entity 1571 (format: E-series, e.g., E-092016307.0010).  If you need support with an IWO, please log a case in <a href="https://apps.powerapps.com/play/e/default-93f33571-550f-43cf-b09f-cd331338d086/a/3ed2946f-ad10-4280-b7e5-7b8925679b53?tenantId=93f33571-550f-43cf-b09f-cd331338d086&hint=08699243-535d-4e2c-8c51-fd4090af3d18&sourcetime=1724413516462" target="_blank">Cosmos</a> under AWS Financial Management/WBS</p>
            </v-flex>
            <v-flex xs12 sm6 offset-md1 md6>
              <v-text-field
                v-model="awsAccountValidation.wbsType"
                label="WBS Type"
                placeholder="WBS Type"
                messages="WBS Type shows here once WBS code is valid"
                disabled
                solo />
            </v-flex>
            <v-flex
              xs12
              sm6
              md5>
              <v-text-field
                v-if="awsAccountValidation.wbsType == 'L-CSC-NonUS WBS'"
                v-model="awsAccountValidation.iwoCode"
                :loading="awsAccountValidation.iwoValidating"
                :success="awsAccountValidation.iwoCodeValidated"
                :error="!awsAccountValidation.iwoCodeValidated"
                :messages="awsAccountValidation.iwoValidationMessage"
                label="Enter IWO Code"
                @keypress="onIwoChange">
                <template v-slot:append>
                  <v-btn
                    :color="awsAccountValidation.iwoCodeValidated ? 'orange' : ''"
                    class="my-0"
                    small
                    @click="onIwoValidate"
                  >
                    <span v-if="!awsAccountValidation.iwoCodeValidated">validate</span>
                    <v-icon
                      v-else
                      small>check</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>
          <div v-if="type !== 'Internal'">
          <div class='acknowledged-section mt-3' v-bind:class="{ les: awsAccountValidation.wbsType == 'L-ES WBS' }" v-if='awsAccountValidation.wbsCodeValidated'>
            <p>NOTE: Please ensure that your WBS code is set up with the correct Major Offering codes </p>
            <p><b>L-ES WBS Codes</b> should be aligned to <b>service line IDATD 6N or ICSEP 6N</b></p>
            <div class='wbs-agreement' v-if="awsAccountValidation.wbsType == 'L-ES WBS' || awsAccountValidation.wbsType == 'L-CSC-US WBS'">
              <p>To validate the major offering code using the following link. The category on the request should be WBS Lookup. <a href='https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx' target='_blank'>https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx</a></p>
            </div>
            <div class='iwo-agreement' v-else>
              <ul>
                <li>GSAP WBS Codes should be aligned to Offering Portfolio – O_P1322168</li>
                <li>C1 WBS Codes should be under C1 Profit Center – P1322168</li>
                <li>To validate the C1 profit center you can look up your WBS under the here: <a href='https://myfrats.csc.com'>https://myfrats.csc.com</a></li>
              </ul>
              <br />
            </div>

             <p> If your WBS Code is set up under any offering other than AWS Cloud Service (I-AWS) please work with your local finance resource to get a code set up under
             <b>Major Offering Code I-AWS</b></p>
              <v-checkbox light
               v-model="awsAccountValidation.agreed"
               :disabled="!awsAccountValidation.iwoCodeValidated && awsAccountValidation.wbsType == 'L-CSC-NonUS WBS'"
               class="mx-2 confirm-validation"
               color="white"
               label="I understand and have validated that the major offering code is properly selected."
               ></v-checkbox>
          </div>

                      
          </div>
          <v-layout row justify-center mt-4 v-if="  type !== 'Internal'">
             <v-btn class="" value="true" @click="goBack"> Go Back to Previous Page</v-btn>
            <!-- <v-btn @click="onAcctCancel">Cancel</v-btn> -->
            <!-- <v-btn :disabled="validatedForSubmission || awsAccountValidation.savedForLater" :loading='awsAccountValidation.savingForLater' @click="onAcctSaveForLater" >Save for later</v-btn> -->
            <v-btn :disabled='validatedForSubmission || awsAccountValidation.savedForLater || awsAccountValidation.savingForLater' color="warning"  :loading='awsAccountValidation.submitting' @click='onAcctValidationSubmit'>Next</v-btn>
          </v-layout>
           <v-layout row justify-center mt-4 v-if="type === 'Internal'">
              <v-btn class="" value="true" @click="goBack"> Go Back to Previous Page</v-btn>
            <!-- <v-btn @click="onAcctCancel">Cancel</v-btn> -->
            <!-- <v-btn :disabled="validatedForSubmission || awsAccountValidation.savedForLater" @click="onAcctSaveForLater" >Save for later</v-btn> -->
            <v-btn :disabled='validatedForSubmission || awsAccountValidation.savedForLater || awsAccountValidation.savingForLater' color="warning"  :loading='awsAccountValidation.submitting' @click='onAcctValidationSubmit'>Next</v-btn>
          </v-layout>

        </v-form>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('user/requestAws', ['awsAccountValidation', 'selectedWorkload','awsAccountOnboarding','dxcRegions','customers']),
   validatedForSubmission () {
      if(this.type !== 'Internal'){
         if (this.awsAccountValidation.wbsType === 'L-CSC-NonUS WBS') {
            if(this.type !== 'New'){
              return !this.awsAccountValidation.agreed || !this.awsAccountValidation.wbsCodeValidated || !this.awsAccountValidation.iwoCodeValidated
            } else {
              return !this.awsAccountValidation.agreed || !this.awsAccountValidation.wbsCodeValidated 
              || !this.awsAccountValidation.iwoCodeValidated || !this.awsAccountOnboarding.fields.Tmp_Cust_Name ||!this. awsAccountOnboarding.fields.Cust_Region || !this.awsAccountOnboarding.fields.Customer_Alias ||  this.errors.items.length
            }
          } else {
            if(this.type !== 'New'){
              return !this.awsAccountValidation.agreed || !this.awsAccountValidation.wbsCodeValidated
            } else {
              return !this.awsAccountValidation.agreed || !this.awsAccountValidation.wbsCodeValidated 
              || this.awsAccountOnboarding.fields.Tmp_Cust_Name === '' ||!this. awsAccountOnboarding.fields.Cust_Region || !this.awsAccountOnboarding.fields.Customer_Alias ||  this.errors.items.length
            }
            
          }
        } else {
           if (this.awsAccountValidation.wbsType === 'L-CSC-NonUS WBS') {
             return !this.awsAccountValidation.wbsCodeValidated || !this.awsAccountValidation.iwoCodeValidated
           } else {
              return !this.awsAccountValidation.wbsCodeValidated 
           }
        }
      }
  },
  mounted () {
   
  },
  beforeDestroy () {
    // this.$store.commit('user/requestAws/clearValidation')
  },
  props: ['type'],
  methods: {
    getCustomerRegion() {
      let custAlias = this.awsAccountOnboarding.fields.Customer_Alias
      let custName = this.awsAccountOnboarding.fields.Tmp_Cust_Name
      let custReg =  this.awsAccountOnboarding.fields.Cust_Region
      let isCustRegExist =  this.customers.filter(res =>  res.Cust_Region.includes(custName+' - '+custReg))
      if(isCustRegExist.length > 0) {
      this.awsAccountOnboarding.isCustRegion = true
      let alias = isCustRegExist[0].Customer_Alias
      this.awsAccountOnboarding.fields.MP_ID = isCustRegExist[0].Master_Id
        console.log('-------- selected customer --------')
        console.log('alias: ' + alias)
        console.log('-----------------------------------')
        if (alias !== 'None'){
            this.awsAccountOnboarding.custRegion =''
            this.awsAccountOnboarding.custRegionId= isCustRegExist[0].Customer_Id
            this.awsAccountOnboarding.fields.Customer_Alias = isCustRegExist[0].Customer_Alias
            this.$store.commit('user/requestAws/setCustomerAlias', alias)
        }  else {
          console.log('customer update...')
            this.awsAccountOnboarding.custRegionAction = 'update'
            this.awsAccountOnboarding.custRegionId = isCustRegExist[0].Customer_Id
            this.awsAccountOnboarding.fields.Customer_Alias =''
            this.$store.commit('user/requestAws/setCustomerAlias', this.awsAccountOnboarding.fields.Customer_Alias)
          } 

      } else {
              console.log('customer create...')
              this.awsAccountOnboarding.fields.Customer_Alias =''
              this.awsAccountOnboarding.custRegionAction = 'post'
              this.awsAccountOnboarding.isCustRegion = false
              this.awsAccountOnboarding.custRegionId=''
              let alias = this.awsAccountOnboarding.fields.Customer_Alias
              this.$store.commit('user/requestAws/setCustomerAlias', alias)
            }
    },
    checkCustRegionAvailability () {
      let custAlias = this.awsAccountOnboarding.fields.Customer_Alias
      let custName = this.awsAccountOnboarding.fields.Tmp_Cust_Name
      let custReg =  this.awsAccountOnboarding.fields.Cust_Region
      let array1 = ['APJ-MEA', 'Americas', 'Europe', 'UKI']
      let array2 = []
      array1.forEach(element => array2.push(custName +' - '+ element ))

      let isCustRegExist =  this.customers.filter(res =>  res.Cust_Region.includes(custName+' - '+custReg))

      if(isCustRegExist.length > 0) {
        this.awsAccountOnboarding.isCustRegion = true
        let alias = isCustRegExist[0].Customer_Alias
        if (alias !== 'None'){
          this.awsAccountOnboarding.custRegion =''
          this.awsAccountOnboarding.custRegionId= ''
          this.awsAccountOnboarding.fields.Customer_Alias = isCustRegExist[0].Customer_Alias
          this.$store.commit('user/requestAws/setCustomerAlias', alias)
        } else {
          this.awsAccountOnboarding.custRegionAction = 'update'
          this.awsAccountOnboarding.custRegionId = isCustRegExist[0].Customer_Id
          this.$store.commit('user/requestAws/setCustomerAlias', this.awsAccountOnboarding.fields.Customer_Alias)
        }
      } else {
        this.awsAccountOnboarding.custRegionAction = 'post'
        this.awsAccountOnboarding.isCustRegion = false
        this.awsAccountOnboarding.custRegionId=''
        let alias = this.awsAccountOnboarding.fields.Customer_Alias
        this.$store.commit('user/requestAws/setCustomerAlias', alias)
      }
    },
    onWbsChange () {
      this.awsAccountValidation.wbsCodeValidated = false
      this.awsAccountValidation.wbsValidationMessage = ''
    },
    onWbsValidate () {
      this.$store.dispatch('user/requestAws/validateWbsCode', this.awsAccountValidation.wbsCode)
    },
    onIwoChange () {
      this.awsAccountValidation.iwoCodeValidated = false
      this.awsAccountValidation.iwoValidationMessage = ''
    },
    onIwoValidate () {
      this.$store.dispatch('user/requestAws/validateIwoCode', this.awsAccountValidation.iwoCode)
    },
    onAcctCancel () {
      this.$emit('cancel')
    },
    onAcctSaveForLater () {
      this.$emit('save-for-later', {
        wbs: this.awsAccountValidation.wbsCode,
        iwo: this.awsAccountValidation.iwoCode
      })
    },
    onAcctValidationSubmit () {
      console.log('type: ' + this.type)
      if(this.type === 'New'){
        this.$emit('submit', {
          wbs: this.awsAccountValidation.wbsCode,
          iwo: this.awsAccountValidation.iwoCode,
          custRegionAction: this.awsAccountOnboarding.custRegionAction, 
          custRegionId: this.awsAccountOnboarding.custRegionId,
          isCustRegion: this.awsAccountOnboarding.isCustRegion,
          custName: this.awsAccountOnboarding.fields.Tmp_Cust_Name,
          custRegion: this.awsAccountOnboarding.fields.Cust_Region,
          custAlias: this.awsAccountOnboarding.fields.Customer_Alias
  
        })
      } else {
        this.$emit('submit', {
          wbs: this.awsAccountValidation.wbsCode,
          iwo: this.awsAccountValidation.iwoCode
        })
      }

    },
    goBack () {
      console.log('Go back!')
      this.$emit('previous')
    }
  }
}
</script>
<style lang="scss">
  .v-select__slot {
    label {
      font-weight: 500
    }
  }
  .awsacct-validation {
    .acknowledged-section {
      padding: 20px;
      background: #ff9900;

      &.les {
        background: yellow;
      }

      a {
        color: #000;
        text-decoration: underline;
      }
    }

    .confirm-validation {
      label {
        color: #000 !important;
        font-weight: 500 !important;
      }
    }
  }
</style>
